var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    fill: "none",
    viewBox: "0 0 35 35"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M17.3 4C9.958 4 4 9.958 4 17.3c0 7.342 5.958 13.3 13.3 13.3 7.342 0 13.3-5.958 13.3-13.3C30.6 9.958 24.642 4 17.3 4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "m11.625 23.378 11.756-11.756M23.375 23.378 11.619 11.622"
  })));
};
export { SvgCloseCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzUiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzNSAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjMgNEM5Ljk1ODQgNCA0IDkuOTU4NCA0IDE3LjNDNCAyNC42NDE2IDkuOTU4NCAzMC42IDE3LjMgMzAuNkMyNC42NDE2IDMwLjYgMzAuNiAyNC42NDE2IDMwLjYgMTcuM0MzMC42IDkuOTU4NCAyNC42NDE2IDQgMTcuMyA0WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiLz4KPHBhdGggZD0iTTExLjYyNSAyMy4zNzc4TDIzLjM4MDYgMTEuNjIyMiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjMuMzc1IDIzLjM3NzhMMTEuNjE5NCAxMS42MjIyIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=";